/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { INetworkSentinel } from './INetworkSentinel';
import { NetworkManager } from './NetworkManager';

export class NetworkSentinel implements INetworkSentinel {
    private static mNetworkSentinel: INetworkSentinel | undefined;

    // TODO: need to use the TiVoSusbscriber module.
    private services: Set<Function>;

    private constructor() {
        this.services = new Set();
        NetworkManager.subscribe(this.handleNetworkChange.bind(this));
    }

    private handleNetworkChange() {
        if (!NetworkManager.isNetworkDisconnected()) {
            this.services.forEach((service) => service());
        }
    }

    public static getInstance(): INetworkSentinel {
        if (!NetworkSentinel.mNetworkSentinel) {
            NetworkSentinel.mNetworkSentinel = new NetworkSentinel();
        }
        return NetworkSentinel.mNetworkSentinel;
    }

    public removeService(service: Function): void {
        this.services.delete(service);
    }

    public addService(service: Function): void {
        this.services.add(service);
    }
}
